export const css = {
	oneaction: '_29wsNy76',
	' _key': 'ascm-theme/ascm/quiz-widgets/pretest-review'
};

export default css;
